import React, { useState, useEffect } from 'react';
import { Search, Download } from 'lucide-react';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:4000/api/v1';

export default function DireccionCertificados() {
    const [certificados, setCertificados] = useState([]);
    const [loading, setLoading] = useState(true);
    const [searchTerm, setSearchTerm] = useState('');

    useEffect(() => { loadCertificados(); }, []);

    const loadCertificados = async () => {
        try {
            setLoading(true);
            const response = await fetch(`${API_URL}/direccion/autorizaciones/certificados`);
            const data = await response.json();
            setCertificados(data.certificados || []);
        } catch (error) {
            console.error('Error:', error);
        } finally {
            setLoading(false);
        }
    };

    const handleEmitirChange = async (id, emitir) => {
        try {
            await fetch(`${API_URL}/direccion/autorizaciones/certificados/${id}`, {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ emitir: emitir === 'emitir' })
            });
            loadCertificados();
        } catch (error) {
            console.error('Error:', error);
        }
    };

    const handleDownloadExcel = () => {
        const headers = ['No', 'Tipo', 'Nombres', 'Apellidos', 'Cédula de Identidad', 'Extensión', 'Complemento',
            'Fecha de Nacimiento', 'Nivel', 'Lugar de Nacimiento', 'Dirección', 'Número de Teléfono/Celular',
            'Correo Electrónico', 'Contacto', 'Parentesco', 'Número de Teléfono/Celular Contacto', 'Nombre Curso', 'Estado'];

        const escapeCSV = (val) => {
            if (val === null || val === undefined) return '';
            const str = String(val);
            if (str.includes(',') || str.includes('"') || str.includes('\n')) {
                return `"${str.replace(/"/g, '""')}"`;
            }
            return str;
        };

        const rows = filtered.map((c, index) => [
            index + 1,
            c.tipo || 'Estudiante',
            c.nombre || '',
            c.apellido || '',
            c.cedula || c.ci || '',
            c.extension || '',
            c.complemento || '',
            c.fecha_nacimiento ? new Date(c.fecha_nacimiento).toLocaleDateString() : '',
            c.nivel || '',
            c.lugar_nacimiento || '',
            c.direccion || '',
            c.telefono || c.celular || '',
            c.email || '',
            c.contacto_nombre || '',
            c.parentesco || '',
            c.contacto_telefono || '',
            c.curso_nombre || '',
            c.certificado_aprobado ? 'Emitir' : 'No Emitir'
        ].map(escapeCSV).join(','));

        const csvContent = [headers.join(','), ...rows].join('\n');
        const blob = new Blob(['\ufeff' + csvContent], { type: 'text/csv;charset=utf-8;' });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = `certificados_${new Date().toISOString().split('T')[0]}.csv`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(link.href);
    };

    const filtered = certificados.filter(c =>
        searchTerm === '' || `${c.nombre} ${c.apellido} ${c.curso_nombre}`.toLowerCase().includes(searchTerm.toLowerCase())
    );

    if (loading) return <div className="p-6 text-center">Cargando...</div>;

    return (
        <div className="p-4 md:p-6 max-w-full mx-auto">
            <div className="mb-6">
                <h1 className="text-xl font-bold text-gray-800">Direccion Academica &gt; Certificados</h1>
            </div>

            {/* Barra de búsqueda y descarga */}
            <div className="mb-4 flex flex-wrap gap-3 items-center">
                <div className="flex-1 max-w-md relative">
                    <input
                        type="text"
                        placeholder=""
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        className="w-full px-4 py-2 border border-gray-300 rounded-full"
                    />
                    <Search className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400" size={18} />
                </div>
                <button
                    onClick={handleDownloadExcel}
                    className="p-2 bg-green-600 text-white rounded-full hover:bg-green-700 transition shadow-sm"
                    title="Descargar Excel"
                >
                    <Download size={20} />
                </button>
            </div>

            {/* Tabla de Inscripciones */}
            <div className="bg-white rounded-lg shadow overflow-hidden mb-8">
                <div className="overflow-x-auto">
                    <table className="w-full text-xs">
                        <thead className="bg-gray-100">
                            <tr>
                                <th className="px-2 py-3 text-center font-semibold border">No</th>
                                <th className="px-2 py-3 text-center font-semibold border">Tipo</th>
                                <th className="px-2 py-3 text-center font-semibold border">Nombres</th>
                                <th className="px-2 py-3 text-center font-semibold border">Apellidos</th>
                                <th className="px-2 py-3 text-center font-semibold border">Cédula de Identidad</th>
                                <th className="px-2 py-3 text-center font-semibold border">Extensión</th>
                                <th className="px-2 py-3 text-center font-semibold border">Complemento</th>
                                <th className="px-2 py-3 text-center font-semibold border">Fecha de Nacimiento</th>
                                <th className="px-2 py-3 text-center font-semibold border">Nivel</th>
                                <th className="px-2 py-3 text-center font-semibold border">Lugar de Nacimiento</th>
                                <th className="px-2 py-3 text-center font-semibold border">Dirección</th>
                                <th className="px-2 py-3 text-center font-semibold border">Número de Teléfono/Celular</th>
                                <th className="px-2 py-3 text-center font-semibold border">Correo Electrónico</th>
                                <th className="px-2 py-3 text-center font-semibold border">Contacto</th>
                                <th className="px-2 py-3 text-center font-semibold border">Parentesco</th>
                                <th className="px-2 py-3 text-center font-semibold border">Número de Teléfono/Celular</th>
                            </tr>
                        </thead>
                        <tbody>
                            {filtered.length === 0 ? (
                                <tr><td colSpan="16" className="px-4 py-8 text-center text-gray-500 border">No hay estudiantes inscritos</td></tr>
                            ) : (
                                filtered.map((c, index) => (
                                    <tr key={c.id_inscripcion} className="hover:bg-gray-50">
                                        <td className="px-2 py-2 text-center border">{index + 1}</td>
                                        <td className="px-2 py-2 text-center border">{c.tipo || '-'}</td>
                                        <td className="px-2 py-2 text-center border">{c.nombre || '-'}</td>
                                        <td className="px-2 py-2 text-center border">{c.apellido || '-'}</td>
                                        <td className="px-2 py-2 text-center border">{c.cedula || c.ci || '-'}</td>
                                        <td className="px-2 py-2 text-center border">{c.extension || '-'}</td>
                                        <td className="px-2 py-2 text-center border">{c.complemento || '-'}</td>
                                        <td className="px-2 py-2 text-center border">{c.fecha_nacimiento ? new Date(c.fecha_nacimiento).toLocaleDateString() : '-'}</td>
                                        <td className="px-2 py-2 text-center border">{c.nivel || '-'}</td>
                                        <td className="px-2 py-2 text-center border">{c.lugar_nacimiento || '-'}</td>
                                        <td className="px-2 py-2 text-center border">{c.direccion || '-'}</td>
                                        <td className="px-2 py-2 text-center border">{c.telefono || c.celular || '-'}</td>
                                        <td className="px-2 py-2 text-center border">{c.email || '-'}</td>
                                        <td className="px-2 py-2 text-center border">{c.contacto_nombre || '-'}</td>
                                        <td className="px-2 py-2 text-center border">{c.parentesco || '-'}</td>
                                        <td className="px-2 py-2 text-center border">{c.contacto_telefono || '-'}</td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                </div>
            </div>

            {/* Tabla de Acciones por Curso */}
            <div className="bg-white rounded-lg shadow overflow-hidden max-w-md">
                <div className="overflow-x-auto">
                    <table className="w-full text-sm">
                        <thead className="bg-gray-100">
                            <tr>
                                <th className="px-4 py-3 text-center font-semibold border">Nombre Curso</th>
                                <th className="px-4 py-3 text-center font-semibold border">Acciones</th>
                            </tr>
                        </thead>
                        <tbody>
                            {filtered.length === 0 ? (
                                <tr><td colSpan="2" className="px-4 py-8 text-center text-gray-500 border">No hay cursos</td></tr>
                            ) : (
                                filtered.map((c) => (
                                    <tr key={c.id_inscripcion} className="hover:bg-gray-50">
                                        <td className="px-4 py-3 text-center border">{c.curso_nombre || '-'}</td>
                                        <td className="px-4 py-3 text-center border">
                                            <select
                                                value={c.certificado_aprobado ? 'emitir' : 'no_emitir'}
                                                onChange={(e) => handleEmitirChange(c.id_inscripcion, e.target.value)}
                                                className={`px-3 py-1 rounded text-sm font-medium border-0 ${c.certificado_aprobado ? 'bg-green-100 text-green-800' : 'bg-gray-100 text-gray-600'
                                                    }`}
                                            >
                                                <option value="no_emitir">No Emitir</option>
                                                <option value="emitir">Emitir</option>
                                            </select>
                                        </td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
}
